import { createAction } from "redux-starter-kit";

export const userSettings = createAction("USER_SETTINGS");

export const userNotifications = createAction("USER_NOTIFICATIONS");